import axios from "axios";
import {url} from "@/service/BASE_URL";
const URL = `${url}/api/quiz`;
function jwtConfig(jwt) {
  return { headers: { Authorization: `Bearer ${jwt}` } };
}

export default {
  upload(file, subjectId, jwt) {
    var formData = new FormData();
    formData.append("file", file);
    return axios.post(
      `${URL}/upload-cvs/${subjectId}`,
      formData,
      jwtConfig(jwt),
    );
  },
  delete(id, jwt) {
    return axios.delete(`${URL}/${id}`, jwtConfig(jwt));
  },
  getBySubject(id, jwt) {
    return axios.get(`${URL}/by-subject/${id}`, jwtConfig(jwt));
  },
};
